import { render } from "./OffcanvasForm.vue?vue&type=template&id=17175825&scoped=true"
import script from "./OffcanvasForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasForm.vue?vue&type=script&lang=js"

import "./OffcanvasForm.vue?vue&type=style&index=0&id=17175825&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17175825"]])

export default __exports__